<template>
    <div id="clientOverviewReport">
        <div class="e-card">
            <div class="row">
                <div class="col-lg-8">
                </div>
                <div class="col mt-2">
                    <ejs-checkbox cssClass="postionCheckCo check-d" ref='defMechCb' :checked="isChecked"
                               @change="updateChecked" label='Default Mechanism' id="contractOverviewDm" name="checkName" floatLabelType='Auto'></ejs-checkbox>
                </div>
                <div class="col mt-2 ">
                    <ejs-button cssClass="e-primary" ref="btnContractOverview" v-on:click.native='btnViewContract'>Contract Overview</ejs-button>
                </div>
            </div>
            <div class="row" v-if="gridPowerData.length > 0">
                <div class="col m-3">
                    <div class="e-control e-grid e-responsive e-default" style="background-color: #d9843b; color: #001c55;">
                        <CIcon name="cil-bolt" style="color: #001c55;" /> Power
                    </div>
                </div>
            </div>
            <div class="row" v-if="gridPowerData.length > 0">
                <div class="col m-3">
                    <ejs-grid ref='gridPower'  :dataBound='dataBoundPower'
                              id="gridPower"
                              :dataSource="gridPowerData"
                              :allowFiltering='false'
                              :allowPaging='false'
                              :allowResizing='true'
                              :allowReordering='false'
                              :allowSorting='false'
                              :autoFitAll='true'
                              :toolbarClick='toolbarClick'
                              :toolbar='toolbar'
                              :queryCellInfo='gasQueryCellInfo'>
                        <e-columns>
                            <e-column textAlign="Center" headerText='Client Details' :columns="clientDetails"></e-column>
                            <e-column textAlign="Center" headerText='Contract Details' :columns="contractDetails"></e-column>
                            <e-column textAlign="Center" headerText='Strategy Details' :columns="strategyDetails"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div class="row" v-if="gridGasData.length > 0">
                <div class="col m-3">
                    <div class="e-control e-grid e-responsive e-default" style="background-color: #7FB7BE; color: #001c55; ">
                        <CIcon name="cil-fire" style="color: #001c55;"/> Gas
                    </div>
                </div>
            </div>
            <div class="row" v-if="gridGasData.length > 0">
                <div class="col m-3">
                    <ejs-grid ref='gridGas'
                              id="gridGas" :dataBound='dataBoundGas'
                              :dataSource="gridGasData"
                              :allowFiltering='false'
                              :allowPaging='false'
                              :allowResizing='true'
                              :allowReordering='false'
                              :allowSorting='false'
                              :autoFitAll='true'
                              :toolbarClick='toolbarClick'
                              :toolbar='toolbar'
                              :queryCellInfo='gasQueryCellInfo'>
                        <e-columns>
                            <e-column textAlign="Center" headerText='Client Details' :columns="gasClientDetails"></e-column>
                            <e-column textAlign="Center" headerText='Contract Details' :columns="gasContractDetails"></e-column>
                            <e-column textAlign="Center" headerText='Strategy Details' :columns="gasStrategyDetails"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </div>
        <div id="contractsReportSpinner"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { GridPlugin, Toolbar, Edit,Resize } from '@syncfusion/ej2-vue-grids';
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DialogUtility } from '@syncfusion/ej2-vue-popups';
    import apis from '../../common/network'
    import store from '../../store';
    import urls from '../../common/urls';

    Vue.use(ButtonPlugin);
    Vue.use(GridPlugin);

    export default {
        created() {
        },
        mounted() {
            createSpinner({
                target: document.getElementById('contractsReportSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById('contractsReportSpinner'));
            this.isChecked = this.getIsClientDefaultMFromLocalStorage();
            this.getData();
        },
        data() {
            return {
                gridPowerData: [],
                gridGasData: [],
                showPowerGrid: true,
                showGasGrid: true,
                isChecked: false,
                defaultMChecked: store.state.isClientDefaultM,
                quarters: ["Q1", "Q2", "Q3", "Q4"],
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddContract' }],
                clientDetails: [{
                    field: 'countryName',
                    headerText: 'Country',
                    textAlign: 'Center',
                },
                {
                    field: 'companyName',
                    headerText: 'Company Name',
                    textAlign: 'Center',
                }
                ],

                gasClientDetails: [{
                    field: 'countryName',
                    headerText: 'Country',
                    textAlign: 'Center',
                },
                {
                    field: 'companyName',
                    headerText: 'Company Name',
                    textAlign: 'Center',
                }],

                contractDetails:[],

                gasContractDetails: [],

                strategyDetails: [{
                    field: 'strategyInPlace',
                    headerText: 'Strategy In Place',
                    textAlign: 'Center',
                },
                {
                    field: 'signedDate',
                    headerText: 'Signed Date',
                    textAlign: 'Center',
                    type: 'date',
                    format: { type: 'date', format: 'dd/MM/yyyy' }
                },
                {
                    field: 'type',
                    headerText: 'Type',
                    textAlign: 'Center',
                }],

                gasStrategyDetails: [{
                    field: 'strategyInPlace',
                    headerText: 'Strategy In Place',
                    textAlign: 'Center',
                },
                {
                    field: 'signedDate',
                    headerText: 'Signed Date',
                    textAlign: 'Center',
                    type: 'date',
                    format: { type: 'date', format: 'dd/MM/yyyy' }
                },
                {
                    field: 'type',
                    headerText: 'Type',
                    textAlign: 'Center',
                }]
            }
        },
        methods: {
            dataBoundGas: function () {
                this.$refs.gridGas.autoFitColumns();
            },
            dataBoundPower: function () {
                this.$refs.gridPower.autoFitColumns();
            },
            toolbarClick(args) {
                if (args.item.id === 'AddContract' && store.state.permissions["Permissions.Contract.Create"]) {
                    this.$router.push({ name: "Contract", params: { clientId: store.state.reportClientId } });
                }
            },
            getData: function () {
                var self = this;
                apis.protectedApi(`report/contractOverview/${store.state.reportClientId}?defaultM=${store.state.isClientDefaultM == true ? true : false}`)
                    .then(response => {
                        hideSpinner(document.getElementById('contractsReportSpinner'));
                        if (response && response.data && (response.data.gas.length > 0 || response.data.power.length > 0)) {
                            var gasSetup = this.transformData(response.data.gas);
                            self.gasContractDetails = gasSetup.columns;
                            self.gridGasData = gasSetup.array;

                            var powerSetup = this.transformData(response.data.power);
                            self.contractDetails = powerSetup.columns;
                            self.gridPowerData = powerSetup.array;
                            this.$refs.defMechCb.ej2Instances.checked = this.defaultMChecked;
                            this.$refs.btnContractOverview.ej2Instances.disabled = false;
                        } else {
                            this.$refs.btnContractOverview.ej2Instances.disabled = true;
                        }
                    }).catch(e => {
                        hideSpinner(document.getElementById('contractsReportSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            updateChecked(event) {
                // Update value in Local Storage-u
                this.setIsClientDefaultMInLocalStorage(event.checked);
                // Update Value in Vuex store-u
                this.$store.commit('setClientCheckDefaultM', event.checked);
                this.getData();
            },
            getIsClientDefaultMFromLocalStorage() {
                const storedValue = localStorage.getItem('defaultMech');
                return storedValue ? JSON.parse(storedValue) : false;
            },
            setIsClientDefaultMInLocalStorage(value) {
                localStorage.setItem('defaultMech', JSON.stringify(value));
            },
            transformData: function (contracts) {
                var formatedColumnNames = [{
                    field: 'comodity',
                    headerText: 'Commodity',
                    textAlign: 'Center',
                },
                {
                    field: 'contractId',
                    headerText: 'Contract ID',
                    textAlign: 'Center',
                },
                {
                    field: 'contractName',
                    headerText: 'Contract Name',
                    textAlign: 'Center',
                },
                {
                    field: 'supplierName',
                    headerText: 'Supplier',
                    textAlign: 'Center',
                },
                {
                    field: "startDate",
                    headerText: "Start Date",
                    textAlign: 'Center',
                    type: 'date',
                    //format: 'dd/MM/yyyy' ,
                    format: { type: 'date', format: 'dd/MM/yyyy' }
                },
                {
                    field: "endDate",
                    headerText: "End Date",
                    textAlign: 'Center',
                    type: 'date',
                    format: { type: 'date', format: 'dd/MM/yyyy' }
                }];
                var outputArray = [];
                contracts.forEach(contract => {
                    let electricityContract = {};
                    for (const property in contract) {
                        if (property !== "quarters") {
                            electricityContract[property] = contract[property];
                        } else {
                            var groups = {};
                            contract[property].forEach(function (item) {
                                var list = groups[item.item1];
                                if (list) {
                                    list.push(item.item2);
                                } else {
                                    groups[item.item1] = [item.item2];
                                }
                            });

                            for (const year in groups) {
                                let yearExists = formatedColumnNames.find(item => item.field === year);
                                if (yearExists) {
                                    var selectedQuarters = groups[year];
                                    this.quarters.forEach(function (quarter) {
                                        const found = selectedQuarters.find(el => el === quarter);
                                        if (found)
                                            electricityContract[year + "." + quarter] = 1;
                                        else {
                                            electricityContract[year + "." + quarter] = 0;
                                        }
                                    });
                                } else {
                                    var y = {
                                        field: year,
                                        headerText: year,
                                        textAlign: 'Center',
                                        columns: [],
                                    };
                                    var selectedQuarters = groups[year];
                                    this.quarters.forEach(function (quarter) {
                                        var q = {
                                            field: year + "." + quarter,
                                            headerText: quarter,
                                            textAlign: 'Right',
                                            width: "60",
                                        };
                                        y.columns.push(q);
                                        const found = selectedQuarters.find(el => el === quarter);
                                        if (found)
                                            electricityContract[year + "." + quarter] = 1;
                                        else {
                                            electricityContract[year + "." + quarter] = 0;
                                        }
                                    });
                                    var position = formatedColumnNames.indexOf(formatedColumnNames.filter(function (val) {
                                        return val.field == parseInt(y.field)+1;
                                    })[0]);
                                    if (position == -1) {
                                        formatedColumnNames.push(y);
                                    } else {
                                        formatedColumnNames.splice(position, 0, y);
                                    }
                                }
                            }

                        }
                    }

                    outputArray.push(electricityContract);
                });
                return {array: outputArray ,columns : formatedColumnNames};
            },
            gasQueryCellInfo: function (args) {

                var start = new Date(args.data.startDate);
                var end = new Date(args.data.endDate);
                var currentTime = new Date();
                var colorPrefix = 'future';
                if (start <= currentTime && end > currentTime) {
                    colorPrefix = 'active'
                } else if (start < currentTime && end < currentTime) {
                    colorPrefix = 'past';
                }
                if (args.column.field.includes('.Q1')) {
                    args.column.headerText = '-';
                    if (args.data[args.column.field] === 1) {
                        args.data[args.column.field] = '';
                        args.cell.classList.add(colorPrefix+'-color');
                    } else {
                        args.data[args.column.field] = '';
                    }
                }
                if (args.column.field.includes('.Q2')) {
                    args.column.headerText = '-';
                    if (args.data[args.column.field] === 1) {
                        args.data[args.column.field] = '';
                        args.cell.classList.add(colorPrefix + '-color');
                    } else {
                        args.data[args.column.field] = '';
                    }
                }
                if (args.column.field.includes('.Q3')) {
                    args.column.headerText = '-';
                    if (args.data[args.column.field] === 1) {
                        args.data[args.column.field] = '';
                        args.cell.classList.add(colorPrefix + '-color');
                    } else {
                        args.data[args.column.field] = '';
                    }
                }
                if (args.column.field.includes('.Q4')) {
                    args.column.headerText = '-';
                    if (args.data[args.column.field] === 1) {
                        args.data[args.column.field] = '';
                        args.cell.classList.add(colorPrefix + '-color');
                    } else {
                        args.data[args.column.field] = '';
                    }
                }
            },
            calculateYears: function (startDate, endDate) {
                var min = new Date(startDate).getFullYear();
                var max = new Date(endDate).getFullYear();
                var years = [];

                for (var i = max; i >= min; i--) {
                    years.push(i);
                }
                return years;
            },
            btnViewContract: function (args) {
                showSpinner(document.getElementById('contractsReportSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateClientContractsOverviewPage/${store.state.reportClientId}?defaultM=${store.state.isClientDefaultM == true ? true : false}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('contractsReportSpinner'));
                }
                ).catch(
                    response => {
                        hideSpinner(document.getElementById('contractsReportSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                       
                    }
                );
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            }
        },
        watch: {
            '$store.state.isClientDefaultM'(newVal) {
                //Sync the local state with the store, ensuring real-time updates on value changes.
                this.isChecked = newVal;
            }
        },
        
        provide: {
            grid: [Edit, Toolbar, Resize]
        }
    }
</script>

<style>
    .past-color {
        background-color: #Dae0f2 !important;
    }
    .future-color {
        background-color: #001c55 !important;
    }
    .active-color {
        background-color: #485696 !important;
    }
    /*.below-80 {
        background-color: yellow;
    }

    .above-80 {
        background-color: greenyellow
    }*/
    .e-checkbox-wrapper .postionCheckCo {
        margin: 0 auto !important;
    }

</style>